import { AppBar, Container, Stack, Toolbar } from "@mui/material";
import { useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import OnboardingNavBar from "src/components/NavBars/OnboardingNavBar/OnboardingNavBar";
import PromoBanner from "src/components/PromoBanner";

interface Props {
  showLanguageSelect?: boolean;
}
const DashboardPaymentLayout = ({ showLanguageSelect = true }: Props) => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <Stack pt={1.5}>
      <AppBar
        position="fixed"
        sx={{
          width: `100%`,
          boxShadow: "none",
          backgroundColor: "#ffffff",
          color: "#000000",
        }}
      >
        <Stack spacing={1}>
          <OnboardingNavBar
            hasNoLanguageSelect={!showLanguageSelect}
            hasNoProgressBar
          />
          <PromoBanner showCountdown />
        </Stack>
      </AppBar>
      <Toolbar />
      <Toolbar />
      <Container
        disableGutters
        maxWidth="sm"
        sx={{
          flexGrow: 1,
          p: 2,
          overflowY: "auto",
          mt: 1,
        }}
      >
        <Outlet />
      </Container>
    </Stack>
  );
};

export default DashboardPaymentLayout;
